import { observer } from "mobx-react-lite";
import { useState } from "react";

import {
  dataAttribute,
  DataAttributes,
  IconButton,
  IContextualMenuItem,
  Stack,
  TooltipHost
} from "@bps/fluent-ui";

import { XeroRemoveOrganisationLinkDialog } from "./XeroRemoveOrganisationLinkDialog.tsx";

interface XeroOrganisationMenuProps {
  tenantId: string;
  setError: (value: string) => void;
}

export const XeroOrganisationMenu: React.FC<XeroOrganisationMenuProps> =
  observer(({ tenantId, setError }) => {
    const [showRemoveModal, setShowRemoveModal] = useState(false);

    const xeroOrganisationMenuItems: IContextualMenuItem[] = [
      {
        key: "remove",
        text: "Remove",
        onClick: () => setShowRemoveModal(true)
      }
    ];

    return (
      <Stack horizontalAlign="center" verticalAlign="center" horizontal>
        <TooltipHost content="More">
          <IconButton
            {...dataAttribute(
              DataAttributes.Element,
              "xero-contextual-menu-btn"
            )}
            onMouseDown={e => e.stopPropagation()}
            menuIconProps={{ iconName: "More" }}
            menuProps={{
              items: xeroOrganisationMenuItems
            }}
            styles={{
              root: { width: "32px", height: "36px", padding: 0 },
              flexContainer: { width: "32px", height: "36px" }
            }}
          />
        </TooltipHost>
        {showRemoveModal && (
          <XeroRemoveOrganisationLinkDialog
            onDismiss={() => setShowRemoveModal(false)}
            showModal={showRemoveModal}
            tenantId={tenantId}
            setError={setError}
          />
        )}
      </Stack>
    );
  });
